import React from 'react';
import { IDishesForModifierGroups } from 'types';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DishesScrollView.module.scss';

interface IDishesScrollView {
	data: IDishesForModifierGroups[];
}

const DishesScrollView: React.FC<IDishesScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="DishesScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.dishName} withTooltip={true} />
							{el.externalId && (
								<ChunkOfTextWithCopying text={el.externalId} className={style.externalId} />
							)}
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(DishesScrollView);
